import __var_0__ from './main.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Add two complex numbers.
*
* @module @stdlib/math/base/complex/add
*
* @example
* var cadd = require( '@stdlib/math/base/complex/add' );
*
* var v = cadd( 5.0, 3.0, -2.0, 1.0 );
* // returns [ 3.0, 4.0 ]
*
* @example
* var cadd = require( '@stdlib/math/base/complex/add' );
*
* var out = new Float32Array( 2 );
*
* var v = cadd( out, 5.0, 3.0, -2.0, 1.0 );
* // returns <Float32Array>[ 3.0, 4.0 ]
*
* var bool = ( out === v );
* // returns true
*/

// MODULES //
var cadd = __var_0__;


// EXPORTS //
export default cadd;
